import { Navigate } from "react-router-dom";
import { isAuth } from "../utils/HelperFunctions";

export default function PublicRoute({ children }) {
  const auth = isAuth();
  return !auth ? children : <Navigate to="/" />;
}
